import { render, staticRenderFns } from "./TaxesSelector.vue?vue&type=template&id=4c048cbc"
import script from "./TaxesSelector.vue?vue&type=script&lang=js"
export * from "./TaxesSelector.vue?vue&type=script&lang=js"
import style0 from "./TaxesSelector.vue?vue&type=style&index=0&id=4c048cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports